module.exports = __webpack_public_path__ + "img/icon_pinglun.3f529a7a.svg";